import { createSlice } from '@reduxjs/toolkit';

export const inventorySlice = createSlice({
    name: 'inventory',
    initialState: {
        isAddInventoryButtonDisable: false,
        inventoryGuid: null,
        currency: '',
        isCopyMode: false,
    },
    reducers: {
        onAddInventoryButtonDisable: (state, action) => {
            state.isAddInventoryButtonDisable = action.payload;
        },
        setOpenedInventoryGuid: (state, action) => {
            state.inventoryGuid = action.payload;
        },
        setCurrencyValue: (state, action) => {
            state.currency = action.payload;
        },
        setIsCopyMode: (state, action) => {
            state.isCopyMode = action.payload;
        },
    },
});

export const {
    setOpenedInventoryGuid,
    onAddInventoryButtonDisable,
    setCurrencyValue,
    setIsCopyMode,
} = inventorySlice.actions;

export default inventorySlice.reducer;
